import React, { useState, useEffect, useCallback, forwardRef } from "react";
import { TextField, InputAdornment, Button } from "@mui/material";
import Checkbox from '@mui/material/Checkbox';
import moment from "moment";
import ModalStyles from "components/Content/Modal/ModalStyles.module.css";
import { Utils } from "common/Utils";

const viewDataOnly = false
const AddEmployeeBenefits = forwardRef(({ fetchedData, hwBenefitDate, employee }, ref) => {
  const [formData, setFormData] = useState(fetchedData);
  const [effectiveDate, setEffectiveDate] = useState(hwBenefitDate);

  useEffect(() => {
    console.log(fetchedData, 'AddEmployeeBenefits')
    setFormData(fetchedData.map(f => ({
      benefit: f.benefit,
      benefitID: f.benefitID,
      benefitCode: f.benefitCode,
      benefitType: f.benefitType,
      benefitCoverageID: f.benefitCoverageID,
      coverage: f.coverage,
      coverageAmount: f.coverageAmount,
      toAdd: false,
    })))
  }, [fetchedData]);

  // const handleChange = useCallback(
  //   (name, val) => {
  //     let updatedValue = { [name]: val };
  //     if (ref?.current) {
  //       ref.current.formData = {
  //         ...formData,
  //         ...updatedValue
  //       };
  //     }
  //     setFormData(formData => ({
  //       ...formData,
  //       ...updatedValue
  //     }));
  //   },
  //   [ref]
  // );
    const benefitTypes = [...new Set(formData.filter(obj => (employee.benefitEnrollments?(!employee.benefitEnrollments.map(b=>b.benefit).includes(obj.benefit)):true)).map(obj => obj.benefitType))];

  const handleCheckBenefit =  useCallback((benefitCoverageId, event) => {
    let data = [...formData]
    let benIdx = data.findIndex(b => (b.benefitCoverageID == benefitCoverageId));
    if (benIdx > -1) {
      data[benIdx].toAdd = event.currentTarget.checked
      data[benIdx].effectiveDate = effectiveDate
      data[benIdx].startDate = effectiveDate
      setFormData(data)
      
      if (ref?.current) {
        ref.current.formData = data;
      }
      console.log(formData.filter(f => (f.toAdd == true)), 'after update')
    }
  },
  [ref]
);

  const handleChangeCoverageAmount = useCallback((benefitCoverageId, event) => {
    let data = [...formData]
    let benIdx = data.findIndex(b => (b.benefitCoverageID == benefitCoverageId));
    if (benIdx > -1) {
      data[benIdx].coverageAmount = event.currentTarget.value
      data[benIdx].effectiveDate = effectiveDate
      data[benIdx].startDate = effectiveDate
      setFormData(data)
      if (ref?.current) {
        ref.current.formData = data;
      }
      console.log(formData.filter(f => (f.coverageAmount > 0)), 'after update')
    }
  },
  [ref]
);

const handleChangeEffectiveDate = useCallback((event) => {
  let data = [...formData]
  for(let i = 0;i<data.length;i++){
    data[i].effectiveDate = event.currentTarget.value
    data[i].startDate = event.currentTarget.value
    setFormData(data)
    if (ref?.current) {
      ref.current.formData = data;
    }
  }
},
[ref]
);

  return (
        (benefitTypes.length==0?<span>No benefits available</span>:(<div>
          <TextField
            variant="standard"
            InputProps={{
              readOnly: viewDataOnly,
            }}
            className={ModalStyles.cField}
            label="Effective Date"
            type="date"
            defaultValue={
              effectiveDate === null && viewDataOnly
                ? "N/A"
                : Utils.convertToDatePicker(effectiveDate)
            }
            onChange={handleChangeEffectiveDate}
    
          />
          {
            benefitTypes.map((benfitType, i) => {
              return (
                <div>
                  <p style={{ fontWeight: 'bold' }}>{benfitType}</p>
                  <table className="table tableall--wrapper ">
                    <thead>
                      <tr>
                        <th role="columnheader"></th>
                        <th role="columnheader">Benefit</th>
                        <th role="columnheader">Coverage Level</th>
                        <th role="columnheader">Benefit Effective Date</th>
                        <th role="columnheader">Coverage Amount</th>
                        <th role="columnheader"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {formData.filter(b => b.benefitType == benfitType).sort((a, b) => { return ((a.benefit < b.benefit) ? 1 : -1); }).map((val, i) => (<tr>
                        <td><Checkbox onChange={(e) => handleCheckBenefit(val.benefitCoverageID, e)}></Checkbox ></td>
                        <td>{val.benefit}</td>
                        <td>{val.coverage}</td>
                        <td>{Utils.formatDate(val.startDate)}</td>
                        <td>
                          <TextField
                            variant="standard"
                            InputProps={{
                              readOnly: viewDataOnly,
                            }}
                            defaultValue={val.coverageAmount}
                            onChange={(e) => handleChangeCoverageAmount(val.benefitCoverageID, e)}
    
                          />
                        </td>
                        <td></td>
                      </tr>))}
                    </tbody>
                  </table>
                </div>
              )
            })
          }
        </div>))    
  )
});

export default AddEmployeeBenefits;